export default __webpack_public_path__ + "static/media/tms_v2.81836afd.svg";